// 고객센터 공용 상수 — 사장님 화면과 슈퍼관리자 화면이 같은 라벨을 써야
// "개선 요청" / "개선요청" 처럼 갈라지지 않는다. 서버의 ENUM 과 키가 1:1 이다.
// (server/routes/support.js CATEGORIES / STATUSES)

export const CATEGORIES = [
    { value: 'bug', label: '버그', variant: 'danger' },
    { value: 'improvement', label: '개선 요청', variant: 'info' },
    { value: 'suggestion', label: '건의', variant: 'primary' },
    { value: 'billing', label: '결제·구독', variant: 'warning' },
    { value: 'other', label: '기타', variant: 'secondary' },
];

export const STATUSES = [
    { value: 'open', label: '답변 대기', variant: 'warning' },
    { value: 'answered', label: '답변 완료', variant: 'success' },
    { value: 'closed', label: '종료', variant: 'secondary' },
];

const byValue = (list) => list.reduce((acc, x) => ({ ...acc, [x.value]: x }), {});

export const CATEGORY_MAP = byValue(CATEGORIES);
export const STATUS_MAP = byValue(STATUSES);

// 서버가 새 enum 값을 먼저 배포하고 클라가 아직 모를 수 있다 — 그 값을 그대로 보여준다.
// (빈 칸이 뜨면 화면이 고장난 것처럼 보인다)
export const categoryMeta = (v) => CATEGORY_MAP[v] || { value: v, label: v || '기타', variant: 'secondary' };
export const statusMeta = (v) => STATUS_MAP[v] || { value: v, label: v || '-', variant: 'secondary' };

// 본문에 휴대폰 번호가 섞여 들어왔는지 — 등록 전에 경고하려고 쓴다.
//
// ⚠️ server/utils/redact.js 의 PHONE_RE 와 **같은 패턴이어야 한다.** 두 쪽이 갈라지면
// "화면엔 경고가 안 떴는데 운영팀 화면에선 가려지는" 식의 혼란이 난다. 서버 코드를
// 공유할 수 없는 자리라 복사해 둔 것이고, 한쪽을 고치면 반대쪽도 고쳐야 한다.
//
// 좁게 잡은 패턴이라 '33,000원'·'2026-06-01'·'12가3456'·'123-45-67890' 은 안 걸린다.
// 한글 표기("공일공 일이삼사")는 못 잡는다 — 그건 운영팀의 수동 가리기가 받는다.
const PHONE_RE = /01[016789][-. ]?[0-9]{3,4}[-. ]?[0-9]{4}/;

export const hasPhone = (text) => PHONE_RE.test(String(text || ''));
